/* eslint-disable eqeqeq */
import axios from "axios";

import {
  ACTenglishScoringMatrix,
  ACTmathScoringMatrix,
  ACTreadingScoringMatrix,
  ACTscienceScoringMatrix,
  SATverbalScoringMatrix,
  SATmathScoringMatrix,
  EqualityMatrix,
  ACTmathScoringMatrixNew,
  ACTreadingScoringMatrixNew,
} from "../components/resultsScoring";

export const BrandColors = {
  brandGreen: "#6AB03D",
  brandDarkGreen: "#477729",
  brandLightGreen: "#BAD7A7",
  brandLightGray: "#D9D9D9",
  brandVeryLightGray: "#f3f3f3",
  brandDarkGray: "#686868",
};

export const CourseFee = 75;

export const StripeKey = process.env.REACT_APP_STRIPE_KEY;

// eslint-disable-next-line no-undef
export const ApiEndpoint = process.env.REACT_APP_API_ENDPOINT;

// eslint-disable-next-line no-undef
export const homeUrl = process.env.REACT_APP_HOME_URL;

// eslint-disable-next-line no-undef
export const imagesUrl = process.env.REACT_APP_IMAGES_URL;

export const pageIds = {
  homepage: "homepage",
  login: "login",
  register: "register",
  register_confirm: "register_confirm",
  register_success: "register_success",
  exam_start: "exam_start",
  section_complete: "section_complete",
  section_end: "section_end",
  exam_complete: "exam_complete",
};

export const checkIfExamComplete = (userData) => {
  let currSection = userData.currentSectionId;
  const sectionLength = userData.examAnswers.length;

  if (currSection >= sectionLength - 2) {
    return true;
  } else {
    return false;
  }
};

export const updateCurrentSection = async (userData) => {
  let temp = { ...userData };
  const SATVerbalMin = 70;
  const SATMathMin = 65;

  const respScore = await axios.post(
    ApiEndpoint + "wp-json/firstchoiceprep/v1/calculateSectionScore",
    {
      token: userData.token,
      sectionId: temp.currentSectionId,
      userid: temp.userid,
    }
  );

  if (temp.currentSectionId === 1 && respScore.data.score >= SATVerbalMin) {
    temp.satVerbalLevel = 1;
    await axios.post(
      ApiEndpoint + "wp-json/firstchoiceprep/v1/updateUserData",
      {
        token: userData.token,
        fields: ["satVerbalLevel"],
        values: [1],
      }
    );
  }

  if (temp.currentSectionId === 6 && respScore.data.score >= SATMathMin) {
    temp.satMathLevel = 1;
    await axios.post(
      ApiEndpoint + "wp-json/firstchoiceprep/v1/updateUserData",
      {
        token: userData.token,
        fields: ["satMathLevel"],
        values: [1],
      }
    );
  }

  let currSection = temp.currentSectionId;
  //choose the correct next section...
  if (temp.currentSectionId == 2) {
    temp.currentSectionId = temp.satVerbalLevel == 1 ? 4 : 3;
  } else if (temp.currentSectionId == 7) {
    temp.currentSectionId = temp.satMathLevel == 1 ? 9 : 8;
  } else if (temp.currentSectionId == 3) {
    temp.currentSectionId = 5;
  } else {
    temp.currentSectionId = currSection + 1;
  }

  temp.currentSection = temp.examAnswers[temp.currentSectionId].sectionTitle;
  const nextQuestion =
    temp.examAnswers[temp.currentSectionId].questions[0].questionId;
  temp.showSectionEndScreen = true;
  temp.lastQuestionAnswered = nextQuestion;
  temp.sectionStartTime = null;
  return temp;
};

export const startNewSection = (userData) => {
  let temp = { ...userData };
  temp.sectionStartTime = new Date().getTime();
  return temp;
};

export const updateUserPaidStatus = async (token, userid) => {
  const resp = await axios.post(
    ApiEndpoint + "wp-json/firstchoiceprep/v1/confirmPayment",
    {
      token,
      userid,
    }
  );
  return resp;
};

const formatAnswerResponse = (question, cat = "SAT", index = 0) => {
  const letters = " ABCDE";
  const letters2 = " FGHJK";
  if (question.questionType === "input") {
    return {
      answer: question.userAnswer,
      correct: question.correctAnswer,
      type: question.questionCategory,
    };
  }

  return cat === "SAT"
    ? {
        answer: letters[question.userAnswerIndex],
        correct: letters[question.correctAnswerIndex],
        type: question.questionCategory,
      }
    : index % 2 === 0
    ? {
        answer: letters[question.userAnswerIndex],
        correct: letters[question.correctAnswerIndex],
        type: question.questionCategory,
      }
    : {
        answer: letters2[question.userAnswerIndex],
        correct: letters2[question.correctAnswerIndex],
        type: question.questionCategory,
      };
};

export const formatResultsData = (response) => {
  const satVerbalLevel = { current: null };
  const satMathLevel = { current: null };
  const resp = response.results;
  //get high level stats...
  const actEnglishScore = ACTenglishScoringMatrix[resp[0].correctAnswer];
  const actMathScore = resp?.legacyACTScoring ? ACTmathScoringMatrix[resp[2].correctAnswer] : ACTmathScoringMatrixNew[resp[2].correctAnswer];
  const actReadingScore = resp?.legacyACTScoring ? ACTreadingScoringMatrix[resp[5].correctAnswer] : ACTreadingScoringMatrixNew[resp[5].correctAnswer];
  const actScienceScore = ACTscienceScoringMatrix[resp[7].correctAnswer];

  const ACTscore = Math.round(
    resp?.legacyACTScoring
      ? (actEnglishScore + actMathScore + actReadingScore + actScienceScore) / 4
      : (actEnglishScore + actMathScore + actReadingScore) / 3
  );

  //calculate which levels to use of the test
  satVerbalLevel.current = resp[1].score >= 70 ? 1 : 0;
  satMathLevel.current = resp[6].score >= 65 ? 1 : 0;

  const satVerbalScore =
    satVerbalLevel.current === 0
      ? SATverbalScoringMatrix.easy[resp[1].correctAnswer][
          resp[3].correctAnswer
        ]
      : SATverbalScoringMatrix.easy[resp[1].correctAnswer][
          resp[4].correctAnswer
        ];
  const satMathScore =
    satMathLevel.current === 0
      ? SATmathScoringMatrix.easy[resp[6].correctAnswer][resp[8].correctAnswer]
      : SATmathScoringMatrix.easy[resp[6].correctAnswer][resp[9].correctAnswer];

  // decide which score is highest
  const satEquivalent = EqualityMatrix[ACTscore];
  let decisionTxt =
    satEquivalent > satVerbalScore + satMathScore ? "the ACT" : "the SAT";

  if (Math.abs(satEquivalent - (satVerbalScore + satMathScore)) <= 20) {
    decisionTxt = "both";
  }

  const actEnglishQuestionData = resp[0]?.questionData.map(
    (question, index) => {
      return formatAnswerResponse(question, "ACT", index);
    }
  );

  const actMathQuestionData = resp[2]?.questionData.map((question, index) => {
    return formatAnswerResponse(question, "ACT", index);
  });

  const actReadingQuestionData = resp[5]?.questionData.map(
    (question, index) => {
      return formatAnswerResponse(question, "ACT", index);
    }
  );

  const actScienceQuestionData = resp[7]?.questionData.map(
    (question, index) => {
      return formatAnswerResponse(question, "ACT", index);
    }
  );

  const satVerbalMod1QuestionData = resp[1]?.questionData.map((question) => {
    return formatAnswerResponse(question);
  });

  const satVerbalMod2QuestionData =
    satVerbalLevel.current === 0
      ? resp[3]?.questionData.map((question) => {
          return formatAnswerResponse(question);
        })
      : resp[4]?.questionData.map((question) => {
          return formatAnswerResponse(question);
        });

  const MathMod1QuestionData = resp[6]?.questionData.map((question) => {
    // console.log(question);
    return formatAnswerResponse(question);
  });

  const satMathMod2QuestionData =
    satMathLevel.current === 0
      ? resp[8]?.questionData.map((question) => {
          return formatAnswerResponse(question);
        })
      : resp[9]?.questionData.map((question) => {
          return formatAnswerResponse(question);
        });
  //create summary table matrices
  let summary_tables = [];

  const tableIds =
    satVerbalLevel.current === 0
      ? [0, 1, 2, 3, 5, 6, 7, -1]
      : [0, 1, 2, 4, 5, 6, 7, -1];

  tableIds[7] = satMathLevel.current === 0 ? 8 : 9;

  tableIds.forEach((tableId, index) => {
    const tableCats = [];
    let table = {
      table_name: resp[tableId].sectionName,
      categories: {},
    };
    let resultData = resp[tableId];
    let isDuplicate = false;

    //combine sat math modules into 1 and verbal into 1
    if (tableId === 1) {
      resultData.questionData = [
        ...resp[tableId].questionData,
        ...resp[tableIds[3]].questionData,
      ];
      table.table_name = "SAT Reading and Writing";
    }
    if (tableId === 6) {
      resultData.questionData = [
        ...resp[tableId].questionData,
        ...resp[tableIds[7]].questionData,
      ];
      table.table_name = "SAT Math";
    }

    if (index === 3 || index === 7) isDuplicate = true;

    resultData.questionData.forEach((item) => {
      if (!tableCats.includes(item.questionCategory)) {
        tableCats.push(item.questionCategory);
        table.categories[item.questionCategory] = {
          title: item.questionCategory,
          value: 0.0,
          correct: 0,
          incorrect: 0,
          len: 0,
        };
      }
      if (item.correctAnswer === item.userAnswer) {
        table.categories[item.questionCategory].value += 1;
        table.categories[item.questionCategory].correct += 1;
      } else {
        table.categories[item.questionCategory].incorrect += 1;
      }
      table.categories[item.questionCategory].len++;
    });
    for (let key in table.categories) {
      const target = table.categories[key];
      target.value = Math.round((target.correct / target.len) * 100).toFixed(2);
    }
    if (!isDuplicate) summary_tables.push(table);
  });

  //reorder the summary tables
  const tempTables = [
    summary_tables[0],
    summary_tables[1],
    summary_tables[2],
    summary_tables[4],
    summary_tables[3],
    null,
    summary_tables[5],
  ];
  summary_tables = tempTables;

  const stats = {
    actEquivalent: 0,
    satEquivalent: 0,
    decision: decisionTxt,
    act_summary: {
      act_score: ACTscore,
      sat_score: satVerbalScore + satMathScore,
      percentile: 807,
      details: {
        english: actEnglishScore,
        math: actMathScore,
        reading: actReadingScore,
        science: actScienceScore,
      },
    },
    sat_summary: {
      act_score: ACTscore,
      sat_score: satVerbalScore + satMathScore,
      percentile: 0,
      details: {
        verbal: satVerbalScore,
        math: satMathScore,
      },
    },
    act_answers: {
      english: actEnglishQuestionData,
      math: actMathQuestionData,
      reading: actReadingQuestionData,
      science: actScienceQuestionData,
    },
    sat_answers: {
      verbal: satVerbalMod1QuestionData,
      verbal2: satVerbalMod2QuestionData,
      math: MathMod1QuestionData,
      math2: satMathMod2QuestionData,
    },
    summary_tables: summary_tables,
    userName: "",
    testDate: "",
  };

  return stats;
};

export const getScoringEquivalents = (actScore, satScore) => {
  const satEquivalent = EqualityMatrix[actScore];
  // if (satScore < 590) return [satEquivalent, "Not Applicable"]
  if (satScore === 1600) return [satEquivalent, 36];
  let actEquivalent = 0 | "";

  Object.keys(EqualityMatrix).forEach((key) => {
    if (satScore >= EqualityMatrix[key]) actEquivalent = key;
  });
  return [satEquivalent, actEquivalent];
};

export const questionCatDescriptions = {
  "Transitions and Directional Words":
    "Transitions and Directional Words - These questions assess students’ ability to choose the appropriate connective word or phrase that best links ideas, maintains the flow of an argument, or clarifies the relationship between concepts in a passage.",
  "Grammar and Syntax":
    "Grammar and Syntax – These questions test the grammatical and syntactically soundness of sentences.  Students should make sure each sentence is grammatically and syntactically sound. They should be mindful of parallel structure, verb tense, subject-verb agreement, pronoun agreement, pronoun ambiguity, and pronoun case, and make sure all transitions and directional words are utilized correctly. They should be wary of redundancies, and generally avoid verbosity and awkwardness.",
  Punctuation:
    "Punctuation – These questions test students’ knowledge of proper use of punctuation marks like commas, semicolons, colons, hyphens, periods, and apostrophes. Also tested in this category are comma splices and run-on sentences and sentence fragments. Students should also be mindful of how punctuation placement affects the meaning of a sentence.",
  "Rhetorical Analysis":
    "Rhetorical Analysis – these questions test students’ ability to interpret and synthesize information from a given text and critically evaluate its significance within a broader context. They require the extraction of relevant details to understand the author's purpose, assess the efficacy of their arguments, and deduce implications. These questions demand a high level of reading comprehension, analytical reasoning, and the ability to make inferences that connect the material to larger themes or historical and cultural phenomena.",
  Arithmetic:
    "Arithmetic – “Arithmetic” questions deal with number theory and pre-algebra concepts like percents, rates, and ratios.",
  Statistics:
    "Statistics – “Statistics” questions deal with statistical concepts and measurements like median, mean, mode, range, and standard deviation.  These questions will also ask students to interpret data graphs and charts, like bar graphs, scatterplots, and stem-and-leaf plots, among others.",
  "Basic Algebra":
    "Basic Algebra – “Basic Algebra” questions deal with the skills and concepts generally taught in Algebra 1, such as solving for one or two variables, graphing lines on the xy-plane, and creating linear equations from word problems.",
  "Advanced Algebra":
    "Advanced Algebra – “Advanced Algebra” questions deal with the skills and concepts generally taught in Algebra 2, such as quadratic functions, exponential functions, and function translations, among other things.",
  Geometry:
    "Geometry – “Geometry” questions deal with geometric shapes and the rules that govern them, as well as simple trigonometry usually taught in geometry classes.",
  Precalculus:
    "Precalculus – “Precalculus” questions test skills and concepts generally taught in precalculus classes, like trigonometric identities, radians, the Unit Circle, and Sine and Cosine graphs.",
  "Long Word Problems":
    "Long Word Problems – These questions test students’ ability to understand convoluted math puzzles.  They are usually longer and more dense than other math questions and test students’ reading comprehension abilities almost as much as their math skills.",
  "Main Idea":
    "Main Idea – “Main Idea” questions gauge a student's ability to identify the central theme or primary argument of a text. They test the synthesis of key points and the distillation of essential messages from details presented.",
  "Analytical Reasoning":
    "Analytical Reasoning – 'Analytical Reasoning' questions evaluate a student's capacity to logically connect ideas and evidence within a text to draw conclusions, support arguments, or extend understanding to new contexts. They test critical thinking and the ability to apply logic to analyze the implications of given information or hypotheses.",
  "Specific Questions":
    "Specific Questions – “Specific Questions” test students’ ability to remember or find specific pieces of information from the text.",
  "Vocab In Context":
    "Vocab in Context – “Vocab in Context” questions evaluate students’ proficiency in interpreting and applying vocabulary based on the surrounding text. They require students to discern nuances in word meaning, understand the connotation and denotation of terms, and select words that precisely fit the context of the passage.",
  "Data Interpretation":
    "Data Interpretation – “Data Interpretation” questions ask you to manipulate and analyze  scientific data presented in scientific tables, graphs, and diagrams (e.g., recognize trends in data, translate tabular data into graphs, interpolate and extrapolate, and reason mathematically). ",
  "Evaluation of Models, Inferences, and Experimental Results":
    "Evaluation of Models, Inferences, and Experimental Results - These questions ask you to judge the validity of scientific information and formulate conclusions and predictions based on that information (e.g., determine which explanation for a scientific phenomenon is supported by new findings).",
  "Scientific Investigation":
    "Scientific Investigation – “Scientific Investigation” questions require students to understand experimental tools, procedures, and design (e.g., identify controls and variables) and compare, extend, and modify experiments (e.g., predict the results of additional trials).",
};

export const pdfHeader = `<!DOCTYPE html><html><head><meta charset="UTF-8"><meta name="viewport" content="width=device-width" initial-scale="1"><meta name="x-apple-disable-message-reformatting"><title></title><style>.resultsPage .headline .img{height: auto;width: 30px;margin-right: 8px;}.resultsPage .matrixDataCol img{height: auto;width: 20px;margin-top: 4px;}.resultsPage .headline h1,.resultsPage .pageContent .resultsHolder .resultsBox .resultsTable .resultsRow p,.resultsPage .pageContent h2,.resultsPage .summary-table-headline h4{font-family:maven,Helvetica Neue,Helvetica,sans-serif;font-style:normal}.resultsPage{display:flex;flex-direction:column;margin:10px auto 0;max-width:1300px;width:100%;font-family:maven,Helvetica Neue,Helvetica,sans-serif;}.resultsPage .header{display:flex;justify-content:flex-end}.resultsPage .userSwitcher{margin-right:35px}.resultsPage .headline h1{display:none;}.resultsPage .pageContent{max-width:1600px!important;padding:0!important;width:100%}.resultsPage .pageContent h2{height:155px;color:#6ab03d;font-size:38px;font-weight:700;line-height:1.3em;margin:0 auto;padding-bottom:53px;padding-top:38px;text-align:center;width:94%}.resultsPage .pageContent .resultsHolder{display:flex;gap:45px;justify-content:space-between;margin:0 auto;width:94%}.resultsPage .pageContent .resultsHolder .resultsBox{width:50%;vertical-align: top;padding-left: 5px;padding-right: 5px;}.resultsPage .pageContent .resultsHolder .resultsBox .headline{color:#000;font-size:28px;font-style:normal;font-weight:700}.resultsPage .pageContent .resultsHolder .resultsBox .headline.active{color:#477729}.resultsPage .pageContent .resultsHolder .resultsBox .headline span{color:#6ab03d;font-size:28px;font-style:normal;font-weight:700}.resultsPage .pageContent .resultsHolder .resultsBox .subheadline{color:#000;font-size:16px;font-style:normal;font-weight:500;line-height:normal;margin-top:10px}.resultsPage .pageContent .resultsHolder .resultsBox .resultsTable{border-radius:10px;display:flex;margin-top:10px;padding:0 20px 0 0}.resultsPage .pageContent .resultsHolder .resultsBox .resultsTable .resultsRow{display:block;margin-right:20px}.resultsPage .pageContent .resultsHolder .resultsBox .resultsTable .resultsRow p{color:#6ab03d;font-size:16px;font-weight:700;line-height:normal;margin:8px 0 0;padding:0}.resultsPage .pageContent .resultsHolder .resultsBox .resultsTable .resultsRow p:nth-child(2){color:#000;font-family:maven,Helvetica Neue,Helvetica,sans-serif;font-size:16px;font-style:normal;font-weight:500;line-height:normal;margin:8px 0 15px}.resultsPage .pageContent hr{border-top:1px solid #c6c6c6;margin:20px 0}.resultsPage .pageContent .answersMatrix{display:flex;flex-direction:column;margin:0 auto;width:94%}.resultsPage .pageContent .answersMatrix .headline{color:#000;font-size:28px;font-style:normal;font-weight:700;margin-top:20px}.resultsPage .pageContent .answersMatrix .headline span{font-weight:500}.resultsPage .pageContent .answersMatrix .subheadline{color:#000;font-size:16px;font-style:normal;font-weight:500;line-height:normal;margin-bottom:32px;margin-top:10px}.resultsPage .pageContent .answersMatrix .matrixTable{display:flex;flex-wrap:wrap;gap:4%;justify-content:space-around;margin-bottom:20px}.resultsPage .pageContent .answersMatrix .matrixTable.two-col{justify-content:flex-start}.resultsPage .pageContent .answersMatrix .matrixTable .matrixColumn{display:flex;flex-direction:column;font-size:14px;margin-bottom:45px;width:48%}.resultsPage .pageContent .answersMatrix .matrixTable .matrixColumn .matrixHeadline{background-color:#6ab03d;color:#000;font-size:22px;font-weight:700;padding:14px;text-align:left}.resultsPage .pageContent .answersMatrix .matrixTable .matrixColumn .matrixHeadline p{margin:0;padding:0 0 5px}.resultsPage .pageContent .answersMatrix .matrixTable .matrixColumn .matrixHeadline span{color:#fff}.resultsPage .pageContent .answersMatrix .matrixTable .matrixColumn .matrixData{display:flex;font-size:12px;padding:5px 3px}.resultsPage .pageContent .answersMatrix .matrixTable .matrixColumn .matrixData:nth-child(2){font-size:12px;font-weight:700}.resultsPage .pageContent .answersMatrix .matrixTable .matrixColumn .matrixData:nth-child(2n+2){background-color:#d9d9d9}.resultsPage .pageContent .answersMatrix .matrixTable .matrixColumn .matrixData .matrixDataCol{font-weight:600;min-width:25%;text-align:center;width:25%}.resultsPage .pageContent .answersMatrix .matrixTable .matrixColumn .matrixData .matrixDataCol svg{display:flex;justify-content:center;margin:7px auto 0; width:15px}.resultsPage .pageContent .answersMatrix .matrixTable .matrixColumn .matrixData .matrixDataCol:first-child{min-width:18%;width:18%}.resultsPage .pageContent .answersMatrix .matrixTable .matrixColumn .matrixData .matrixDataCol:nth-child(2),.resultsPage .pageContent .answersMatrix .matrixTable .matrixColumn .matrixData .matrixDataCol:nth-child(3){min-width:20%;width:20%}.resultsPage .pageContent .answersMatrix .matrixTable .matrixColumn .matrixData .matrixDataCol:nth-child(4){min-width:40%;width:40%}.resultsPage .pageContent .answersMatrix .matrixTable .matrixColumn .matrixData .matrixDataCol.incorrect p{color:red}.resultsPage .pageContent .answersMatrix .matrixTable .matrixColumn .matrixData .matrixDataCol.unanswered{background:repeating-linear-gradient(45deg,#b8d9a0,#b8d9a0 10px,#8cd95d 0,#8cd95d 20px)}.resultsPage .pageContent .answersMatrix .matrixTable .matrixColumn .matrixData .matrixDataCol p{margin:0;overflow-wrap:break-word;padding:0 5px 5px}.resultsPage .pageContent .answersMatrix .matrixTable .matrixColumn.sat .matrixHeadline{background-color:#000;color:#6ab03d;margin-bottom:0}.resultsPage .pageContent .answersMatrix .matrixTable .matrixColumn.sat .matrixHeadline.subheadline{background-color:#fff;border-bottom:1px solid #d9d9d9}.resultsPage .pageContent .answersMatrix .matrixTable .matrixColumn.sat .matrixData.first-row{background-color:#bad7a7;font-size:14px;font-weight:700}.resultsPage .summary-table-headline{background-color:#6ab03d;color:#fff;display:flex;flex-direction:column;margin-top:30px;padding:30px}.resultsPage .summary-table-headline h4{font-size:32px;font-weight:700;line-height:29px;margin:0;text-align:left}.resultsPage .summary-table-headline p{color:#fff;font-size:16px;margin-top:10px;text-align:left}.resultsPage .summary-table-holder{background-color:#6ab03d;display:flex;flex-wrap:wrap;justify-content:space-between;padding:0 30px}.resultsPage .summaryTable{margin:0 0 20px 0;}.resultsPage .summaryTable .headline{background:#6ab03d;color:#fff;font-size:24px;font-style:normal;font-weight:800;padding:10px 0}.resultsPage .summaryTable .tableHolder{display:flex;flex-direction:row;flex-wrap:wrap;gap:35px;max-height:80px}.resultsPage .summaryTable .tableHolder .tableRow{color:#fff;display:flex;flex-direction:column;font-size:12px;font-weight:700;text-align:left;}.resultsPage .summaryTable .tableHolder .tableRow p{margin:0}.resultsPage .summaryTable .tableHolder .tableRow p.catName{font-size:15px;margin-bottom:8px}.resultsPage .summaryTable .tableHolder .tableRow p span{color:#000}.resultsPage .summaryTable .tableHolder .tableRow .tableCol.donut{height:100px;margin:20px auto 10px;width:100px}.resultsPage .resultsBox svg{width:20px;margin-right:8px}.CircularProgressbar{vertical-align:middle;width:100%}.CircularProgressbar .CircularProgressbar-path{stroke:#3e98c7;stroke-linecap:round;transition:stroke-dashoffset .5s}.CircularProgressbar .CircularProgressbar-trail{stroke:#d6d6d6;stroke-linecap:round}.CircularProgressbar .CircularProgressbar-text{fill:#3e98c7;dominant-baseline:middle;text-anchor:middle;font-size:20px}.CircularProgressbar .CircularProgressbar-background{fill:#d6d6d6}.CircularProgressbar.CircularProgressbar-inverted .CircularProgressbar-background{fill:#3e98c7}.CircularProgressbar.CircularProgressbar-inverted .CircularProgressbar-text{fill:#fff}.CircularProgressbar.CircularProgressbar-inverted .CircularProgressbar-path{stroke:#fff}.CircularProgressbar.CircularProgressbar-inverted .CircularProgressbar-trail{stroke:transparent}.tableCol{vertical-align: text-top;}.tableCol p{margin:0}</style> <style>*,*:after,*:before{-webkit-box-sizing:border-box;-moz-box-sizing:border-box;box-sizing:border-box}*{-ms-text-size-adjust:100%;-webkit-text-size-adjust:100%}html,body,.document{width:100%!important;height:100%!important;margin:0;padding:0}body{-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale;text-rendering:optimizeLegibility}div[style*="margin: 16px 0"]{margin:0!important}table,td{mso-table-lspace:0;mso-table-rspace:0}table{border-spacing:0;border-collapse:collapse;table-layout:fixed;margin:0 auto}img{-ms-interpolation-mode:bicubic;max-width:100%;border:0}*[x-apple-data-detectors]{color:inherit!important;text-decoration:none!important}.x-gmail-data-detectors,.x-gmail-data-detectors *,.aBn{border-bottom:0!important;cursor:default!important}.btn{-webkit-transition:all 200ms ease;transition:all 200ms ease}.btn:hover{background-color:dodgerblue}@media screen and (max-width:750px){.container{width:100%;margin:auto}.stack{display:block;width:100%;max-width:100%}}.resultsPage .pageContent .answersMatrix>tbody>tr:nth-child(5){page-break-before: always;}.resultsPage hr:nth-child(1){display:none}tr.matrixData{max-height: 55px}.answersMatrix > tbody > tr:nth-child(3) {page-break-before: always;}.results > table:nth-child(3){page-break-before:always;}.resultsPage .headline h2{font-family:maven,"Helvetica Neue",Helvetica,sans-serif;font-style:normal;font-weight:700;font-size:18px;line-height:29px;text-align:center;margin:0;padding:0;height:auto;width:100%}.resultsPage .headline h2 span{color:#477729} .resultsPage .pageContent .resultsHolder .resultsBox .resultsTable .resultsRow{display:flex; gap: 5px; flex-direction:row}</style></head><body> <div style="display: none; max-height: 0px; overflow: hidden;"></div><table role="presentation" aria-hidden="true" cellspacing="0" cellpadding="0" border="0" align="center" class="document"> <tr> <td valign="top"> <table role="presentation" aria-hidden="true" cellspacing="0" cellpadding="0" border="0" align="center" width="750" class="container"> <tr> <td> <table role="presentation" aria-hidden="true" cellspacing="0" cellpadding="0" border="0" align="center" width="100%"> <tr> <td> &nbsp; </td></tr><tr> <td align="center"> <img src="https://testing.firstchoiceprep.com/wp-content/uploads/2018/02/logo.png"/> </td></tr><tr> <td align="center"></td></tr><tr><td>`;

export const pdfFooter = `</td></tr><tr> <td align="center"> <hr/> </td></tr><tr> <td align="center"> <p>© 2024 FIRST CHOICE PREP. ALL RIGHTS RESERVED.</td></tr></table> </td></tr></table> </td></tr></table></body></html>`;
